module.exports = __webpack_public_path__ + "img/illustration.74bb1149.svg";